import { AbstractControl, ValidatorFn } from '@angular/forms';

export function fieldsMatch(fieldName: string): ValidatorFn {
  return (control: AbstractControl): {[key: string]: any} => {
    const fieldValue = control.root.value[fieldName];
    const controlValue = control.value;

    return (fieldValue === controlValue) ?  null : { match: true };
  };
}



// WEBPACK FOOTER //
// /var/www/lantago-app/lantago-app-demo/src/app/core/validators/fields-match.validator.ts